import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {logoutAction} from '../rootAction';
import {ServiceAgreementProps} from '../../components/pages/project-creation/components/AurServiceAgreementDropdown';
import {SelectedClientState, setClientData} from './selectedClientSlice';
import {setSelectedClientId} from './clientListSlice';

export enum PROJECT_CREATION_PATH {
  ClientOverview = 'ClientOverview',
  ClientDetails = 'ClientDetails',
}

interface ProjectCreationState {
  projectCreationInitiatedFrom: PROJECT_CREATION_PATH | null;
  serviceAgreementList: ServiceAgreementProps[];
  selectedAgreement?: ServiceAgreementProps;
  clientId?: string | null;
}

const initialState: ProjectCreationState = {
  projectCreationInitiatedFrom: null,
  serviceAgreementList: [],
  selectedAgreement: undefined,
};

const projectCreationSlice = createSlice({
  name: 'projectCreation',
  initialState,
  reducers: {
    setProjectCreationInitiatedFrom: (
      state,
      action: PayloadAction<PROJECT_CREATION_PATH | null>
    ) => {
      state.projectCreationInitiatedFrom = action.payload;
    },
    setServiceAgreementList: (
      state,
      action: PayloadAction<ServiceAgreementProps[]>
    ) => {
      state.serviceAgreementList = action.payload;
    },

    storeSelectedAgreement: (
      state,
      action: PayloadAction<ServiceAgreementProps | undefined>
    ) => {
      state.selectedAgreement = action.payload;
    },
    setClientIdForProjectCreation: (
      state,
      action: PayloadAction<string | undefined | null>
    ) => {
      state.clientId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });

    // trigger action when client is selected from home screen for welcome single client
    builder.addCase(
      setClientData,
      (state, action: PayloadAction<SelectedClientState>) => {
        if (state.clientId !== action.payload.clientId) {
          state.projectCreationInitiatedFrom = null;
          state.serviceAgreementList = [];
          state.selectedAgreement = undefined;
        }
        state.clientId = action.payload.clientId;
      }
    );

    // Trigger action when client selected from Manage client
    builder.addCase(
      setSelectedClientId,
      (state, action: PayloadAction<string>) => {
        if (state.clientId !== action.payload) {
          state.projectCreationInitiatedFrom = null;
          state.serviceAgreementList = [];
          state.selectedAgreement = undefined;
        }
        state.clientId = action.payload;
      }
    );
  },
});

export const {
  setProjectCreationInitiatedFrom,
  storeSelectedAgreement,
  setServiceAgreementList,
  setClientIdForProjectCreation,
} = projectCreationSlice.actions;
export default projectCreationSlice.reducer;
